import { receiverImgName } from 'shared/receivers/receivers-helpers';


const dateSentWidth = '190px';
const statusWidth = '110px';
const resendWidth = '110px';
const sentToWidth = `calc(100% - ${dateSentWidth} - ${statusWidth} - ${resendWidth})`;

export const columns: any = [
  {
    title: 'Sent To',
    width: sentToWidth,
    sortable: true,
    sort: 'desc',
    sortName: 'receiver_name',
    active: false,
    col: 'receiver_name',
    type: 'html',
    data: receiverImgName,
  },
  {
    title: 'Date sent',
    width: dateSentWidth,
    sortable: true,
    sort: 'desc',
    sortName: 'date_sent',
    active: false,
    col: 'date_sent',
    type: 'date',
  },
  {
    title: 'Status',
    width: statusWidth,
    sortable: true,
    sort: 'desc',
    sortName: 'status',
    active: false,
    col: 'status'
  },
  {
    title: '',
    width: resendWidth,
    sortable: false,
    active: false,
    col: 'resend'
  },
];
